(function () {
    'use strict';

    // Usage: <ib-header-basket-insurances-allianz-fusion ng-if="basketCtrl.model?.insuranceAllianzFusionInfo?.hasInsuranceAllianzFusion" model="basketCtrl.model?.insuranceAllianzFusionInfo" basketFunctions="basketCtrl.commonsBasketFunctions" deleteFlag="basketCtrl.model?.discountsModel?.hasDiscounts && (model?.discountsModel?.discounts?.DYNAMIC_PRICING?.type !== 'DYNAMIC_PRICING' ? true: false)" loadingVoucher="basketCtrl.isLoadingVoucher"></ib-booking-header-basket-insurances-allianz-fusion>
    //
    // Creates:
    //
    angular
        .module('ib-ancillaries-allianz-fusion-insurances-module')
        .component('ibHeaderBasketInsurancesAllianzFusion', {
            controller: 'AllianzFusionController',
            controllerAs: 'allianzFusionCtrl',
            bindings: {
                model: '=',
                basketFunctions: '=',
                deleteFlag: '=',
                loadingVoucher: '='
            },
            templateUrl: ['$rootScope', function ($rootScope) {
                return $rootScope.routes.templates + 'ib-allianz-fusion-view.html';
            }]
        });
})();